import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
`;

const Box = styled.div<{ $dynamicHeight?: boolean; $minWidth?: string }>`
  min-width: ${({ $minWidth }) => $minWidth || '150px'};
  width: 173px;
  border-radius: 2px;
  background: var(--elevation-light);
  border: 1px solid var(--elevation-light-border);

  padding: 24px 0 0 24px;
  ${({ $dynamicHeight }) =>
    $dynamicHeight ? 'padding-bottom: 24px' : 'height: 135px'};
  text-transform: uppercase;

  .isMobileStyle & {
    padding: 14px 0 0 14px;
    ${({ $dynamicHeight }) =>
      $dynamicHeight ? 'padding-bottom: 14px' : 'height: 88px'};
    flex: 1;
  }
`;

const BoxAuto = styled(Box)`
  flex: 1;
  min-width: ${({ $minWidth }) => $minWidth || '220px'};
  .isMobileStyle & {
    min-width: 100%;
    cursor: pointer;
  }
`;

const BoxLarge = styled(Box)`
  flex: 1;
  min-width: ${({ $minWidth }) => $minWidth || '250px'};
  .isMobileStyle & {
    min-width: 100%;
    cursor: pointer;
  }
`;

const Box100percent = styled(BoxLarge)`
  flex: 1;
  min-width: ${({ $minWidth }) => $minWidth || '250px'};
  padding: 16px;
  height: 103px;
`;

const Value = styled.div`
  font-size: var(--large);
  line-height: 27px;
  color: #fff;
  margin-top: 8px;
  /* padding-bottom: 8px; */

  ${BoxLarge} & {
    /* font-weight: 300; */
    margin-top: 0;
    font-size: var(--largestMobile);
    line-height: 54px;
  }
  .isMobileStyle ${BoxLarge} & {
    font-size: var(--large);
    line-height: 1.5;
  }
  .isMobileStyle ${Box100percent} & {
    font-size: var(--largestMobile);
    line-height: 1.5;
  }
`;

// const ValueCentered = styled(Value)`
//   text-align: center;
//   padding-right: 24px;
// `;

const Title = styled.div`
  font-size: var(--smallest);
  /* identical to box height */
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: #a3a8b0;
`;

/** Stats Boxes */
export const statBoxes = {
  Wrap,
  Box,
  BoxAuto,
  BoxLarge,
  Box100percent,
  Title,
  Value,
  // ValueCentered,
};
